"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createExternal = exports.updateAll = exports.create = exports.getLayersOnStarmap = exports.getLayersOnMainCamera = exports.ELayerType = exports.getLayers = exports.getMasterLayers = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
function getMasterLayers() {
    assert_sidecar_1.assert.notNil(_masterLayers);
    return _masterLayers;
}
exports.getMasterLayers = getMasterLayers;
function getLayers() {
    assert_sidecar_1.assert.notNil(_layers);
    return _layers;
}
exports.getLayers = getLayers;
var ELayerType;
(function (ELayerType) {
    ELayerType[ELayerType["None"] = 0] = "None";
    ELayerType[ELayerType["Game"] = 1] = "Game";
    ELayerType[ELayerType["Starmap"] = 2] = "Starmap";
    ELayerType[ELayerType["Ui"] = 3] = "Ui";
})(ELayerType = exports.ELayerType || (exports.ELayerType = {}));
var _masterLayers = null;
var _layers = null;
var _layersOnMainCamera = [];
function getLayersOnMainCamera() {
    return _layersOnMainCamera;
}
exports.getLayersOnMainCamera = getLayersOnMainCamera;
var _layersOnStarmap = [];
function getLayersOnStarmap() {
    return _layersOnStarmap;
}
exports.getLayersOnStarmap = getLayersOnStarmap;
var depth = 100;
function create() {
    var scene = common_sidecar_1.common.getPhaserScene();
    _masterLayers = {
        ship: scene.add.layer(),
        // starmap: scene.add.layer(),
        ui: scene.add.layer(),
        debug: scene.add.layer(),
    };
    _layers = {
        starfield1: createLayer(ELayerType.Game, _masterLayers.ship),
        starfield2: createLayer(ELayerType.Game, _masterLayers.ship),
        dungeon: createLayer(ELayerType.Game, _masterLayers.ship),
        ship1: createLayer(ELayerType.Game, _masterLayers.ship),
        ship2: createLayer(ELayerType.Game, _masterLayers.ship),
        ship3: createLayer(ELayerType.Game, _masterLayers.ship),
        ship4: createLayer(ELayerType.Game, _masterLayers.ship),
        shipSplatter: createLayer(ELayerType.Game, _masterLayers.ship),
        shipCrew: createLayer(ELayerType.Game, _masterLayers.ship),
        shipCrewItem: createLayer(ELayerType.Game, _masterLayers.ship),
        shipAbove: createLayer(ELayerType.Game, _masterLayers.ship),
        particles: createLayer(ELayerType.Game, _masterLayers.ship),
        uiOnCam: createLayer(ELayerType.Game, _masterLayers.ship),
        uiGame: createLayer(ELayerType.Game, _masterLayers.ui, true),
        ui1: createLayer(ELayerType.Game, _masterLayers.ui, true),
        starmapBack: createLayer(ELayerType.Starmap, _masterLayers.ui),
        starmapLocation: createLayer(ELayerType.Starmap, _masterLayers.ui),
        starmapTop: createLayer(ELayerType.Starmap, _masterLayers.ui),
        uiMenu: createLayer(ELayerType.Ui, _masterLayers.ui, true),
        uiMenuMain: createLayer(ELayerType.Ui, _masterLayers.ui, true),
        uiMessage: createLayer(ELayerType.Ui, _masterLayers.ui, true),
        debug: createLayer(ELayerType.Ui, _masterLayers.debug),
    };
}
exports.create = create;
function updateAll() { }
exports.updateAll = updateAll;
function createExternal(baseLayer) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var c = scene.add.container(0, 0);
    baseLayer.add(c);
    return c;
}
exports.createExternal = createExternal;
function createLayer(type, masterLayer, isUi) {
    if (isUi === void 0) { isUi = false; }
    var scene = common_sidecar_1.common.getPhaserScene();
    assert_sidecar_1.assert.notNil(masterLayer);
    assert_sidecar_1.assert.notNil(_masterLayers);
    var c = scene.add.container(0, 0);
    masterLayer.add(c);
    // masterLayer.add(c)
    c.depth = depth;
    depth += 100;
    if (type === ELayerType.Game) {
        if (!isUi) {
            _layersOnMainCamera.push(c);
        }
    }
    if (type === ELayerType.Starmap) {
        if (!isUi) {
            _layersOnStarmap.push(c);
        }
    }
    if (isUi) {
        c.scrollFactorX = 0;
        c.scrollFactorY = 0;
    }
    return c;
}
